import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const RbPreset = definePreset(Aura, {
  components: {
    accordion: {
      // header: {
      //   background: 'var(--p-surface-100);',
      //   hover: {
      //     background: 'gray',
      //   },
      //   active: {
      //     background: 'darkgray',
      //     hover: {
      //       background: 'gray',
      //     },
      //   },
      // },
    },
    datatable: {
      header: {
        borderWidth: '0',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
  },
});

export default RbPreset;
